import React, { ReactNode, ReactNodeArray } from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import ProblemDomainSelectionBlockData from '../../../Models/Content/ProblemDomainSelectionBlockData';
import ProblemDomainFlow from './problemDomainFlow';

export default class ProblemDomainSelectionBlock extends EpiComponent<ProblemDomainSelectionBlockData> {
  public render(): ReactNode | ReactNodeArray | null {
    return (
      <div className="problem-domain-selection-block">
        {React.createElement(ProblemDomainFlow, { iContent: this.props.data })}
      </div>
    );
  }
}